import React from 'react';

import cx from 'classnames';

import { EDetailsMode } from 'components/Pages/Admin/Itinerary/Details/types';
import { AIWysiwygWrapper } from 'components/shared/AIWysiwygWrapper';
import { Alert } from 'components/shared/Alert';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import { OnChangeState } from 'components/shared/Wysiwyg/Wysiwyg.types';
import { LOREM_IPSUM_TEXT, SYMBOLS_LIMIT } from 'constants/texts';
import { EBlockType, IBlock } from 'detailsv2/__blocks';

import { getPrefix } from '../../../../utils';
import { useBlockContext } from '../../Block/context';
import { useReadonlyBlockClick } from '../functions';
import s from './index.module.css';
import { IRichTextProps } from './types';

function RichText({ limit }: IRichTextProps) {
  const { block, readonly, onAdd, onUpdate, onDelete } = useBlockContext<IBlock<EBlockType.Text>>();
  const { data, meta } = block;
  const { template = 'default' } = data;

  const handleChange = (newObject: OnChangeState) => {
    onUpdate?.({
      ...block,
      ...newObject,
    });
  };
  const handleClick = useReadonlyBlockClick();
  const wrapClasses = React.useMemo(
    () =>
      cx(s.wrapper, 'custom-text-wrapper', {
        [s.boxWrapper]: template === 'box',
        [getPrefix('text-box-wrapper')]: template === 'box',
        [s.noIndent]: meta?.indent === false,
      }),
    [template],
  );
  //@ts-ignore
  const placeholder = React.useMemo(() => data?.placeholder?.text || LOREM_IPSUM_TEXT, [data]);

  if (template === 'notification') {
    return (
      <Alert
        variant="info"
        className={wrapClasses}
        content={
          <>
            {/*@ts-ignore*/}
            <Wysiwyg
              type="primary"
              data={data}
              placeholder={placeholder}
              onChange={handleChange}
              onDelete={onDelete}
              limit={limit}
              isReadOnly={readonly}
              bodyClassName={s.alert}
            />
          </>
        }
      />
    );
  }

  return (
    <div className={wrapClasses} onClick={block.meta?.readonly ? handleClick : () => {}}>
      <AIWysiwygWrapper detailsMode={EDetailsMode.Chronological} data={data} onAdd={onAdd!} onUpdate={handleChange}>
        {({ onChange, handleKeyBindingFn, handleKeyCommand, WysiwygFooter }) => (
          <Wysiwyg
            type="primary"
            data={data}
            placeholder={placeholder?.text || LOREM_IPSUM_TEXT}
            focusedPlaceholder="Write something, or type “ / ” for AI..."
            onChange={(state) => {
              onChange(state);
              handleChange(state);
            }}
            onDelete={onDelete}
            handleKeyBinding={handleKeyBindingFn}
            handleKeyCommand={handleKeyCommand}
            limit={SYMBOLS_LIMIT}
            isReadOnly={readonly}
            hideLimit
            footer={<WysiwygFooter />}
          />
        )}
      </AIWysiwygWrapper>
    </div>
  );
}

export default RichText;
